"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSelectContainer = exports.StyledSelect = exports.StyledReadOnly = exports.StyledOptionGroup = exports.StyledOption = exports.StyledLabel = exports.StyledErrorText = exports.StyledDropdownRequired = exports.StyledContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _vectors = _interopRequireDefault(require("../../vectors"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getArrowElement = function getArrowElement(_ref) {
  var dropdown = _ref.dropdown;
  var name = dropdown.arrowVector,
      size = dropdown.arrowSize;
  var getStyle = typeof window !== 'undefined' && window.getComputedStyle;
  var color = '#000000';
  var value = dropdown.arrowColorDisabled || dropdown.arrowColor;

  if (typeof document !== 'undefined') {
    color = getStyle(document.documentElement).getPropertyValue("--".concat(value));
  }

  return (0, _vectors["default"])({
    color: color,
    name: name,
    size: size,
    returnAs: 'data-uri'
  });
};

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "Dropdownstyles__StyledContainer",
  componentId: "sc-1sydz9k-0"
})(["", " ", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["w-100 relative v-top"]))), function (_ref2) {
  var _theme$dropdown;

  var theme = _ref2.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$dropdown = theme.dropdown) === null || _theme$dropdown === void 0 ? void 0 : _theme$dropdown.overrides;
});

exports.StyledContainer = StyledContainer;

var StyledDropdownRequired = _styledComponents["default"].span.withConfig({
  displayName: "Dropdownstyles__StyledDropdownRequired",
  componentId: "sc-1sydz9k-1"
})(["", " text-indent:0.15rem;"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref3) {
  var disabled = _ref3.disabled,
      theme = _ref3.theme;
  return disabled ? theme.dropdown.disabledLabel : 'red';
}));

exports.StyledDropdownRequired = StyledDropdownRequired;

var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "Dropdownstyles__StyledLabel",
  componentId: "sc-1sydz9k-2"
})(["", " color:", ";cursor:default;font-weight:", ";box-sizing:border-box;font-size:", ";", " pointer-events:none;transition:all 0.15s ease;width:100%;", " ", " span:nth-child(2){", "}"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 h-100 mh0 mt0 mb2 pa0 border-box top-0 left-0 flex lh-solid z-1 nowrap\n    ", "\n  "])), function (_ref4) {
  var dropdown = _ref4.theme.dropdown;
  return (dropdown === null || dropdown === void 0 ? void 0 : dropdown.label) || 'sans-serif';
}), function (_ref5) {
  var dropdown = _ref5.theme.dropdown;
  return (dropdown === null || dropdown === void 0 ? void 0 : dropdown.color) || 'var(--near-black)';
}, function (_ref6) {
  var dropdown = _ref6.theme.dropdown;
  return (dropdown === null || dropdown === void 0 ? void 0 : dropdown.fontWeight) || 300;
}, function (_ref7) {
  var _formComponents$fontS;

  var formComponents = _ref7.theme.formComponents;
  return (formComponents === null || formComponents === void 0 ? void 0 : (_formComponents$fontS = formComponents.fontSize) === null || _formComponents$fontS === void 0 ? void 0 : _formComponents$fontS.label) || '14px';
}, function (_ref8) {
  var floatingLabel = _ref8.floatingLabel;
  return floatingLabel && (0, _styledComponents.css)(["margin-top:", ";padding-left:10px;padding-bottom:0px;position:absolute;"], function (props) {
    return props.size === 'normal' ? '14px' : '13px';
  });
}, function (_ref9) {
  var floatingLabel = _ref9.floatingLabel,
      focus = _ref9.focus;
  return focus && floatingLabel && (0, _styledComponents.css)(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref10) {
    var theme = _ref10.theme;
    return theme.dropdown.focusBorderColor;
  }));
}, function (_ref11) {
  var filled = _ref11.filled,
      floatingLabel = _ref11.floatingLabel,
      focus = _ref11.focus;
  return (focus || filled) && floatingLabel && (0, _styledComponents.css)(["margin-top:6px;font-size:9px;font-weight:400;position:absolute;left:0;text-align:left;"]);
}, (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["b"]))));

exports.StyledLabel = StyledLabel;

var StyledReadOnly = _styledComponents["default"].div.withConfig({
  displayName: "Dropdownstyles__StyledReadOnly",
  componentId: "sc-1sydz9k-3"
})(["", ""], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    absolute w-100 h-100 top-0 left-0\n  "]))));

exports.StyledReadOnly = StyledReadOnly;

var StyledSelect = _styledComponents["default"].select.withConfig({
  displayName: "Dropdownstyles__StyledSelect",
  componentId: "sc-1sydz9k-4"
})(["&&{", " border-width:", ";border-style:solid;border-bottom-width:", ";appearance:none;background:var(--white);box-sizing:border-box;color:", ";outline:0;padding-left:0;text-indent:0.5rem;text-overflow:unset;transition:border-color 0.3s ease;width:100%;font-size:", ";&:focus{", " + label{", "}}", " :disabled{cursor:not-allowed;", " + label{", "}}}"], (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n      ", "\n      ", "\n    "])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.dropdown.borderRadius;
}, function (_ref13) {
  var error = _ref13.error,
      theme = _ref13.theme;
  return error ? theme.dropdown.borderErrorColor || 'b--red' : theme.dropdown.borderColor;
}), function (_ref14) {
  var theme = _ref14.theme;
  return theme.dropdown.borderWidth;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.dropdown.borderBottomWidth;
}, function (_ref16) {
  var dropdown = _ref16.theme.dropdown;
  return (dropdown === null || dropdown === void 0 ? void 0 : dropdown.color) || 'var(--near-black)';
}, function (_ref17) {
  var formComponents = _ref17.theme.formComponents;
  return formComponents === null || formComponents === void 0 ? void 0 : formComponents.fontSize.input;
}, (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref18) {
  var theme = _ref18.theme;
  return "b--".concat(theme.dropdown.focusBorderColor);
}), (0, _ty["default"])(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.dropdown.focusBorderColor;
}), function (_ref20) {
  var floatingLabel = _ref20.floatingLabel;
  return floatingLabel && (0, _styledComponents.css)(["text-indent:-100vw;&:focus,&.filled{text-indent:0.5rem;color:var(--near-black);outline:0;padding-top:13px;padding-bottom:0px;}"]);
}, (0, _ty["default"])(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["b--mid-gray bg-mid-gray"]))), (0, _ty["default"])(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["dark-gray"]))));

exports.StyledSelect = StyledSelect;

var StyledSelectContainer = _styledComponents["default"].div.withConfig({
  displayName: "Dropdownstyles__StyledSelectContainer",
  componentId: "sc-1sydz9k-5"
})(["position:relative;&:before{position:absolute;content:url(\"", "\");z-index:1;font-family:sans-serif;color:var(--", ");pointer-events:none;right:", ";bottom:13px;", "}& > select{font-size:", ";height:", ";}"], function (_ref21) {
  var theme = _ref21.theme;
  return getArrowElement(theme);
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.dropdown.arrowColor;
}, function (_ref23) {
  var _theme$dropdown2;

  var theme = _ref23.theme;
  return (theme === null || theme === void 0 ? void 0 : (_theme$dropdown2 = theme.dropdown) === null || _theme$dropdown2 === void 0 ? void 0 : _theme$dropdown2.arrowPosition) || '1rem';
}, function (_ref24) {
  var disabled = _ref24.disabled;
  return disabled && (0, _styledComponents.css)(["filter:grayscale(100%);opacity:0.5;"]);
}, function (props) {
  return props.size === 'normal' ? '0.875rem;' : '0.75rem;';
}, function (_ref25) {
  var size = _ref25.size,
      inputDropdownHeight = _ref25.theme.formComponents.inputDropdownHeight;
  return size === 'normal' ? inputDropdownHeight.normal : inputDropdownHeight.small;
});

exports.StyledSelectContainer = StyledSelectContainer;

var StyledErrorText = _styledComponents["default"].div.withConfig({
  displayName: "Dropdownstyles__StyledErrorText",
  componentId: "sc-1sydz9k-6"
})(["", ""], (0, _ty["default"])(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["red sans-serif mt1 f6"]))));

exports.StyledErrorText = StyledErrorText;

var StyledOption = _styledComponents["default"].option.withConfig({
  displayName: "Dropdownstyles__StyledOption",
  componentId: "sc-1sydz9k-7"
})(["", ""], (0, _ty["default"])(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["pl2"]))));

exports.StyledOption = StyledOption;

var StyledOptionGroup = _styledComponents["default"].optgroup.withConfig({
  displayName: "Dropdownstyles__StyledOptionGroup",
  componentId: "sc-1sydz9k-8"
})(["padding:0.5rem 1rem;"]);

exports.StyledOptionGroup = StyledOptionGroup;